import { WELCOME_MODAL_NAME } from 'components/Account/WelcomeModalComponent/WelcomeModalComponent';
import CreateMessageComponent from 'components/Message/CreateMessageComponent/CreateMessageComponent';
import ContainerComponent from 'components/Tool/ContainerComponent/ContainerComponent';
import Footer from 'pages/Client/Footer/Footer';
import Header from 'pages/Client/Header/Header';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { selectAuthUser } from 'store/authSlice';
import { openModal } from 'store/modalSlice';
import { useAppDispatch } from 'store/store';
import './CreateMessage.css';

function CreateMessage() {
  const dispatch = useAppDispatch();
  const user = useSelector(selectAuthUser);
  const location = useLocation();

  useEffect(() => {
    if (user && !user.isInitialized) {
      dispatch(openModal({ name: WELCOME_MODAL_NAME }));
    }
  }, [dispatch, user]);

  return (
    <>
      <div className="create-message layout-full-height">
        <Header />

        <ContainerComponent className="layout-main-content-flex">
          <>
            <CreateMessageComponent
              initMessageType={location.state?.messageType}
              initMessageTemplate={location.state?.messageTemplate}
              initStep={location.state?.step}
            />
          </>
        </ContainerComponent>

        <Footer />
      </div>
    </>
  );
}

export default CreateMessage;
